import * as cookieManager from "js-cookie";
import { OriginWebAuthClient } from "@origin-digital/origin-auth";

export async function logOut() {
  const logoutSapUrl = window.auth0Config.apiPath + "/v1/logout";

  try {
    await logOutFromSAP(logoutSapUrl);
  } catch (e) {}

  cleanUp();
  logoutFromAuth0();
}

async function logOutFromSAP(logoutSapUrl: string) {
  const reqBody = {
    oauthToken: cookieManager.get("user-token")
  };

  const response = await fetch(logoutSapUrl, {
    method: "POST",
    headers: new Headers({
      "Content-Type": "application/json",
      "x-api-key": window.auth0Config.apiKey
    }),
    body: JSON.stringify(reqBody)
  });

  return response.json();
}

function logoutFromAuth0() {
  const originWebAuthClient = new OriginWebAuthClient(window.auth0Config);
  originWebAuthClient.logoutAndClearLocalStorage();
}

function cleanUp() {
  [
    "mrhSession",
    "lastMrhSession",
    "user-token",
    "is-logged-in",
    "aem-cookie",
    "last-active",
    "bpid",
    "___fn",
    "pmid"
  ].forEach(key => {
    cookieManager.remove(key, { path: "/" });
  });

  if (window.ContextHub) {
    window.ContextHub.getStore("originmyacc").reset(false);
  }

  if (!localStorage.getItem("originStore.logoutType")) {
    localStorage.setItem("originStore.logoutType", "manual");
  }
}
